// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { ClaimTypeDocument } from "./documents/claim-type-document";
import { ItemEnvelope } from "./base/item-envelope";

export class ClaimTypeEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "ClaimType");
		if (jsonEnvelope) {
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public override Document: ClaimTypeDocument = new ClaimTypeDocument();
	public override get ItemId(): number { return this.Document.Item.ClaimTypeId; }
	public override get ItemName(): string { return this.Document.Item.UID; }
}